/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UndercarriageFleetSummaryResponse
 */
export interface UndercarriageFleetSummaryResponse {
    /**
     * 
     * @type {number}
     * @memberof UndercarriageFleetSummaryResponse
     */
    assetId?: number;
    /**
     * 
     * @type {string}
     * @memberof UndercarriageFleetSummaryResponse
     */
    assetName?: string;
    /**
     * 
     * @type {string}
     * @memberof UndercarriageFleetSummaryResponse
     */
    siteName?: string;
    /**
     * 
     * @type {string}
     * @memberof UndercarriageFleetSummaryResponse
     */
    customerName?: string;
    /**
     * 
     * @type {Date}
     * @memberof UndercarriageFleetSummaryResponse
     */
    lastInspectionDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof UndercarriageFleetSummaryResponse
     */
    lastMachineHours?: number | null;
}

/**
 * Check if a given object implements the UndercarriageFleetSummaryResponse interface.
 */
export function instanceOfUndercarriageFleetSummaryResponse(value: object): value is UndercarriageFleetSummaryResponse {
    return true;
}

export function UndercarriageFleetSummaryResponseFromJSON(json: any): UndercarriageFleetSummaryResponse {
    return UndercarriageFleetSummaryResponseFromJSONTyped(json, false);
}

export function UndercarriageFleetSummaryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UndercarriageFleetSummaryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'assetId': json['assetId'] == null ? undefined : json['assetId'],
        'assetName': json['assetName'] == null ? undefined : json['assetName'],
        'siteName': json['siteName'] == null ? undefined : json['siteName'],
        'customerName': json['customerName'] == null ? undefined : json['customerName'],
        'lastInspectionDate': json['lastInspectionDate'] == null ? undefined : (new Date(json['lastInspectionDate'])),
        'lastMachineHours': json['lastMachineHours'] == null ? undefined : json['lastMachineHours'],
    };
}

export function UndercarriageFleetSummaryResponseToJSON(json: any): UndercarriageFleetSummaryResponse {
    return UndercarriageFleetSummaryResponseToJSONTyped(json, false);
}

export function UndercarriageFleetSummaryResponseToJSONTyped(value?: UndercarriageFleetSummaryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assetId': value['assetId'],
        'assetName': value['assetName'],
        'siteName': value['siteName'],
        'customerName': value['customerName'],
        'lastInspectionDate': value['lastInspectionDate'] === null ? null : ((value['lastInspectionDate'] as any)?.toISOString()),
        'lastMachineHours': value['lastMachineHours'],
    };
}

